import { RFI, OCRAEMEA, OCRAANZ } from './businessSegmentBrandIds'
import { getTrustedBaseUrl } from './isTrustedUrl'

const SUPPORTED_LOCALES = new Set([
	'en',
	'fr',
	'de_DE',
	'fr_FR',
	'en_GB',
	'au_AU',
	'en_US',
	'fr_CA',
])

function normalizeHelpLocale(locale, mode) {
	return SUPPORTED_LOCALES.has(locale) ? locale : getDefaultLocale(mode)
}

function normalizeModeParam(mode, modeParam) {
	if (mode === RFI) {
		return 'rfi'
	}
	return typeof modeParam === 'string' && /^[a-zA-Z0-9_-]+$/.test(modeParam)
		? modeParam
		: ''
}

export function createWcaPingWidget(
	{
		appId,
		brandId,
		helpUrl,
		targetUrl,
		panelTitleColor,
		panelBackgroundColor,
		errorFontColor,
		buttonColor,
		buttonFontColor,
		panelFontFamily,
	},
	mode,
) {
	const params = new URLSearchParams(window.location.search)
	const locale = params.get('locale') || getDefaultLocale(mode)
	const modeParam = params.get('mode')
	const baseUrl = getTrustedBaseUrl(targetUrl)

	// Add /fordpro path for fordpro mode
	let finalTargetUrl = targetUrl
	let finalLoginUrl = baseUrl
	let finalSelfRegURL = 'index.html'
	if (mode === 'fordpro') {
		finalSelfRegURL = '/fordpro/index.html'
		finalLoginUrl = baseUrl ? `${baseUrl}/fordpro` : '/fordpro'
	}

	const loginWidgetStyle = {
		panelTitleColor,
		panelBackgroundColor,
		errorFontColor,
		buttonColor,
		buttonFontColor,
		panelFontFamily,
	}
	return new window.WCAWidget({
		appId,
		brandId,
		helpURL: setHelpUrl(mode, modeParam, locale),
		targetUrl: finalTargetUrl,
		loginUrl: finalLoginUrl,
		isPingEnabled: true,
		language: setLanguage(),
		panelStyle: loginWidgetStyle,
		userIdLabel: 'User ID',
		isLoginEmbedded: true,
		selfRegURL: finalSelfRegURL,
		loginErrorContainer: document.getElementById('wcaErrorMessages'),
	})
}

export function setLanguage() {
	const params = new URLSearchParams(window.location.search)
	const locale = params.get('locale')
	switch (locale) {
		case 'en':
			return 'en_US'
		case 'fr':
			return 'fr_CA'
		case 'de_DE':
			return 'de_DE'
		case 'fr_FR':
			return 'fr_FR'
		case 'en_GB':
			return 'en_GB'
		case 'au_AU':
			return 'au_AU'
		default:
			return 'en_US'
	}
}

export function setHelpUrl(mode, modeParam, locale) {
	const location = window.location
	const baseUrl = location.href.split('#')[0].split('?')[0]
	const safeMode = normalizeModeParam(mode, modeParam)
	const safeLocale = normalizeHelpLocale(locale, mode)
	const params = []
	if (location.search && safeMode) {
		params.push(`mode=${encodeURIComponent(safeMode)}`)
	}
	if (location.search && safeLocale) {
		params.push(`locale=${encodeURIComponent(safeLocale)}`)
	}
	params.push('faqs')
	return `${baseUrl}?${params.join('&')}`
}

export function getDefaultLocale(mode = '') {
	if (mode === OCRAEMEA) {
		return 'en_GB'
	}
	if (mode === OCRAANZ) {
		return 'au_AU'
	}
	return 'en_US'
}
